import dayjs from 'dayjs';
import { useLocale } from 'next-intl';
import { LOCALE_DATE_FORMAT } from 'src/lib/constants';

const DisplayStartEndDate: React.FC<{
  startDate: string;
  endDate: string | null;
}> = ({ startDate, endDate }) => {
  const locale = useLocale();
  const UIDateFormat = LOCALE_DATE_FORMAT[locale].UIDateFormat;

  if (endDate && dayjs(endDate).isAfter(startDate)) {
    return `${dayjs(startDate).format(UIDateFormat)} - ${dayjs(endDate).format(UIDateFormat)}`;
  } else {
    return dayjs(startDate).format(UIDateFormat);
  }
};

export default DisplayStartEndDate;
